import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'progress-kolecko',
    standalone: true,
    imports: [NgIf],
    templateUrl: './progress-kolecko.html',
    styleUrl: './progress-kolecko.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ProgressKoleckoComponent {
    @Input() progress = 0; // 0–100 %
    @Input() strokeWidth = 8;
    @Input() showLabel = false;

    get radius(): number {
        return 50 - this.strokeWidth / 2 - 2;
    }

    get circumference(): number {
        return 2 * Math.PI * this.radius;
    }

    get dashOffset(): number {
        const clamped = Math.max(0, Math.min(100, this.progress));
        return this.circumference * (1 - clamped / 100);
    }

}
